import reducer from './reducer';

export const { openRestrictedAccessModal, closeRestrictedAccessModal, continueRestrictedAccessModal } = reducer.actions;
